import { useEffect, useState } from "react";

// True once the drawer's slide-in animation has had time to finish.
//
// Mounting heavy content — a Google Map, a big image grid — in the same
// frames as the slide makes the animation stutter: both compete for the main
// thread. Drawers gate that content on this hook and show a skeleton during
// the slide, so the sheet glides in empty-but-styled and the expensive work
// starts only once it's parked.
//
// Chakra's bottom-sheet spring runs ~300ms; 350 leaves a little headroom.
export const useDrawerSettled = (isOpen, delay = 350) => {
  const [settled, setSettled] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setSettled(false);
      return undefined;
    }
    const timer = setTimeout(() => setSettled(true), delay);
    return () => clearTimeout(timer);
  }, [isOpen, delay]);

  return settled;
};
